import "react";
import { Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { MdEdit } from "react-icons/md";
import { isArray } from "lodash";
//#region src/modules/shared/LabeledInput/LabeledInputDisplay.tsx
function LabeledInputDisplay({ displayOnly = false, label, nameElement, showInput, toggleShowInput, value }) {
	return /* @__PURE__ */ jsxs("div", {
		onClick: () => {
			if (!displayOnly && toggleShowInput) toggleShowInput();
		},
		className: classnames({
			"cursor-pointer": !displayOnly,
			"hover:bg-neutral-faded": !displayOnly
		}, "p-xxs bg-input-background group flex h-10 min-h-10 w-full justify-center rounded transition-colors"),
		children: [/* @__PURE__ */ jsxs("div", {
			className: "flex w-full flex-col content-center space-x-0.5 truncate",
			children: [/* @__PURE__ */ jsx("div", {
				className: "text-neutral min-w-fit content-center text-xs font-bold",
				children: label
			}), /* @__PURE__ */ jsx("div", {
				className: classnames({ "text-neutral-faded": !showInput && (!value || isArray(value) && !value?.length) }, "flex truncate text-xs"),
				children: !showInput && (!value || isArray(value) && !value?.length) ? "None Selected" : nameElement
			})]
		}), !displayOnly && /* @__PURE__ */ jsx("div", {
			className: "inline-flex items-center justify-center",
			children: /* @__PURE__ */ jsx(Icon, {
				className: "ml-xs text-color-neutral-faded group-hover:text-color-semantic opacity-50 transition-colors",
				Icon: MdEdit,
				size: "xs"
			})
		})]
	});
}
//#endregion
export { LabeledInputDisplay };

//# sourceMappingURL=LabeledInputDisplay.js.map